import { ModulesSearchParams, ModuleUniqueKey, Module, DataVisualizationListItemSchema } from '@modules';

/**
 ContentCenter utils.
 @returns {variable}
 */

export const getModuleUniqueKey = (query: ModulesSearchParams): ModuleUniqueKey =>
  query.searchType === 'deployment' ? ModuleUniqueKey.id : ModuleUniqueKey.editableModuleId;

export function isModule(obj: any): obj is Module {
  return obj && typeof obj === 'object' && 'templateName' in obj;
}

export function isDataVisualization(obj: any): obj is DataVisualizationListItemSchema {
  return obj && typeof obj === 'object' && 'name' in obj && !('templateName' in obj);
}
